import { QueryClient } from '@tanstack/react-query'

import { ApiError } from './api-error'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      // Only retry failures that can plausibly succeed on a second attempt;
      // 4xx responses fail fast instead of hammering the API.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && !error.isRetryable) return false
        return failureCount < 2
      },
    },
    mutations: {
      retry: false,
    },
  },
})
